const GenericEngine = require('GenericEngine');
const AudioManager = require('AudioManager');
const AudioMap = require('AudioMap');
const PanelController = require('PanelController');
const FreespinCounter = require('FreespinCounter');
const FSPopupController = require('FSPopupController');
const ParallaxController = require('ParallaxController');
const CameraController = require('CameraController');
const WildProgressController = require('WildProgressController');
const GenericUI = require('GenericUI').ui;
const PSEvents = require('PSEvents');
const PSState = require('PSState');
const { GameStates, FeatureStates } = require('ClientStates');
const DayNightController = require('DayNightController');
const SlotUI = require('SlotUI');

const AUTOPLAY_DELAY = 0.4;
const TOTAL_FREESPIN_COUNT = 15;

cc.Class({
    extends: cc.Component,

    properties: {
        panel: PanelController,
        freespinCounter: FreespinCounter,
        freespinPopup: FSPopupController,
        parallaxController: ParallaxController,
        camera: CameraController,
        wildProgress: WildProgressController,
        dayNightController: DayNightController,
    },

    onLoad() {
        this.audioManager = cc.find('AudioManager').getComponent(AudioManager);
        this.audioMap = cc.find('AudioMap').getComponent(AudioMap);
        this.isFastMode = PSState.quickSpinFeature;

        this.featureGameMode = FeatureStates.INACTIVE;
        this.dayNightController.day = true;
        this.musicId = this.audioMap.playMusic('musicIntro');
    },

    onDestroy() {
        PSEvents.removeAllListenerByTarget(this);
    },

    start () {
        // register events for correct replay
        GenericUI.hideStatusBar();

        this.parallaxController.setTo(0, 0);
        this.scheduleOnce(() => {
            this.camera.zoomTo(1, 1);
        }, 0.5);
        this.freespinCounter.node.active = false;
        this.wildProgress.setMain();
    },

    showScene() {
        const { paylines, paytable } = PSState.gameConfiguration;
        this.panel.initConfig(paylines, paytable);
        this._setupInitialData();

        this.parallaxController.moveTo(-20, 0, 3).then(() => this.startGame());
        this.audioManager.fadeOutMusic(2000, this.musicId, true, () => {
            this.musicId = this.audioMap.playMusic('musicMain');
        });
    },

    showSceneImmediate() {
        const { paylines, paytable } = PSState.gameConfiguration;
        this.panel.initConfig(paylines, paytable);
        this._setupInitialData();

        this.parallaxController.setTo(-20, 0);
        this.camera.zoomTo(1, 0);
        this.audioManager.fadeOutMusic(2000, this.musicId, true, () => {
            this.musicId = this.audioMap.playMusic('musicMain');
        });

        this.scheduleOnce(() => {
            this.startGame();
        })
    },


    startGame() {
        // this.camera.zoomTo(1, 1);

        // this.audioMap.playMusic('musicMain');
        this.registerButtonHandlers();
        this.registerEngineHandlers();
        this.registerPanelHandlers();

        GenericUI.startGame();
    },

    availableActionsHandler(data) {
        if (data) {
            this.state = data.gameState;
            this.prevState = data.prevState;
            if (data.mainSpecialWildProgress) {
                this.mainSpecialWildProgress = data.mainSpecialWildProgress;
            }
            if (data.fsSpecialWildProgress) {
                this.fsSpecialWildProgress = data.fsSpecialWildProgress;
            }
            if (this.featureGameMode === FeatureStates.ENTER) {
                this.lastMainData = data.newPanelData;
                this.lastSplits = data.splits;
            }
            this.panel.setPanelData(data, PSState.betAmount);
        } else {
            cc.error('no available actions data');
        }
    },

    registerButtonHandlers() {
        PSEvents.subscribe(PSEvents.BUTTON_SLAMSTOP, () => {
            this.panel.slamStop();
        }, this);
        PSEvents.subscribe(PSEvents.BUTTON_SPIN, () => {
            // this.audioMap.playOneShot('Spinn Button');
        }, this);
        PSEvents.subscribe(PSEvents.SPIN_REQUEST, () => {
            this.panel.spin(this.isFastMode);
        }, this);
    },

    registerPanelHandlers() {
        this.panel.node.on('stateIdle', () => {
            GenericUI.actionEndRequest();
            if (this.currentMusicVolume !== 1) {
                this.audioManager.fadeMusic(this.currentMusicVolume, 1, 1000, this.musicId);
                this.currentMusicVolume = 1;
            }
            switch (this.featureGameMode) {
                case FeatureStates.ENTER:
                    this.panel.startFreespinAnimation();
                    this.freespinPopup.show();
                    GenericUI.disableSpinButton();
                    this.dayNightController.playNight(3);
                    this.wildProgress.set(this.fsSpecialWildProgress);

                    this.audioManager.fadeOutMusic(1000, this.musicId, true, () => {
                        this.musicId = this.audioMap.playMusic('musicFsIntro');
                    });
                    this.freespinPopup.node.once('show', () => {
                        GenericUI.setCustomSpinButtonHandler(() => {
                            this.onFreespinsPopupButtonClick();
                        }, true);
                    });
                    break;
                case FeatureStates.EXIT:
                    this.freespinCounter.hide();
                    GenericUI.disableSpinButton();
                    this.scheduleOnce(() => {

                        this.panel.showFreespinsTotal(this.freespinsTotalPrize);
                        this.audioManager.fadeOutMusic(500, this.musicId, true, () => {
                            this.musicId = this.audioMap.playMusic('musicFsTotal');
                        });
                    }, AUTOPLAY_DELAY * 1.5);
                    break;
                case FeatureStates.INACTIVE:
                    if (this.isAutoplay) {
                        this.scheduleOnce(() => {
                            GenericUI.roundAnimationEndRequest();
                        }, AUTOPLAY_DELAY);
                    } else {
                        if (this.state === GameStates.MAIN) {
                            this.wildProgress.set(this.mainSpecialWildProgress);
                            GenericUI.roundAnimationEndRequest();
                            this.panel.showWinnings();
                        } else {
                            this.scheduleOnce(() => {
                                GenericUI.roundAnimationEndRequest();
                            }, AUTOPLAY_DELAY);
                        }
                    }
                    break;
                case FeatureStates.ACTIVE://FREESPINS
                    if (this.prevState === GameStates.RETRIGGERING) {
                        this.wildProgress.set(this.fsSpecialWildProgress);
                    }

                    if (this.retriggeredFreeSpins) {
                        this.freespinCounter.totalFreespins(this.retriggeredFreeSpins);
                        this.totalFreespinsCount = this.retriggeredFreeSpins;

                    }
                    this.scheduleOnce(() => {
                        GenericUI.roundAnimationEndRequest();
                    }, AUTOPLAY_DELAY);
                    break;
            }

        }, this);

        this.panel.node.on('freespinTotalPrizeEnd', () => {
            GenericUI.setCustomSpinButtonHandler(() => {
                this.panel.slamStop();
            }, true);
        });

        this.panel.node.on('finishing', () => {
            GenericUI.disableSpinButton();
            this.wildProgress.set(this.mainSpecialWildProgress);
            this.dayNightController.playDay();

            const { preCookedReels, taxonomy } =
                PSState.gameConfiguration.panelConfigurationPerState.FREESPINS;
            this.panel.destroyPanel();
            this.panel.setInitialPanelData({ panelData: this.lastMainData, splits: this.lastSplits },
                this.betAmount, preCookedReels.reels, taxonomy);
        }, this);

        this.panel.node.on('freespinsEnd', () => {
            const { preCookedReels, taxonomy } =
                PSState.gameConfiguration.panelConfigurationPerState.FREESPINS;
            this.panel.destroyPanel();
            this.panel.setInitialPanelData({ panelData: this.lastMainData, splits: this.lastSplits },
                this.betAmount, preCookedReels.reels, taxonomy);

            this.startMainState();
            this.audioManager.fadeOutMusic(1000, this.musicId, true, () => {
                this.musicId = this.audioMap.playMusic('musicMain');
            });

            GenericUI.setDefaultSpinButtonHandler();
            GenericUI.freeSpinsEndRequest();
            GenericUI.roundAnimationEndRequest();
            this.featureGameMode = FeatureStates.INACTIVE;
        }, this);
        this.panel.node.on('bigWinAnimationStart', (isBigWin) => {
            this.currentMusicVolume = isBigWin? 0: .3;
            this.audioManager.fadeMusic(1, this.currentMusicVolume, 500, this.musicId);
        }, this);
        this.panel.node.on('winAnimationSetSlamStop', () => {
            GenericUI.setSlamStopState();
        }, this.node);
    },

    registerEngineHandlers() {
        PSEvents.subscribe(PSEvents.AUTOPLAY_START, () => {
            this.isAutoplay = true;
            this.panel.autoplayState = true;
        }, this);
        PSEvents.subscribe(PSEvents.AUTOPLAY_ENDED, () => {
            this.panel.autoplayState = false;
            this.isAutoplay = false;
        }, this);
        PSEvents.subscribe(PSEvents.SPIN_RESPONSE, (data) => {
            this.availableActionsHandler(data);
        }, this);
        PSEvents.subscribe(PSEvents.GENERIC_FREE_SPIN_START, (data) => {
            this.featureGameMode = FeatureStates.ENTER;
            this.totalFreespinsCount = TOTAL_FREESPIN_COUNT;
            this.freespinCounter.setFreespins(0 , TOTAL_FREESPIN_COUNT);
        }, this);
        PSEvents.subscribe(PSEvents.GENERIC_FREE_SPIN_END, (data) => {
            this.freespinsTotalPrize = data.context.freeSpinsAccumulatedWinnings;
            this.featureGameMode = FeatureStates.EXIT;
        }, this);
        PSEvents.subscribe(PSEvents.GENERIC_FREE_SPIN_PROGRESS, (data) => {
            const currentFreespinsRemaining = this.freespinCounter.getFreespins();
            const condition = this.totalFreespinsCount - data.context.freeSpinRemaining !== 0;

            this.freespinCounter.increment();

            if (currentFreespinsRemaining === this.totalFreespinsCount) {
                this.totalFreespinsCount = 0;
                this.freespinCounter.totalFreespins(this.totalFreespinsCount);
                // this.freespinCounter.increment();
            } else if (currentFreespinsRemaining > this.totalFreespinsCount - data.context.freeSpinRemaining && condition) {
                if (data.context.freeSpinRemaining > this.totalFreespinsCount && this.totalFreespinsCount === 0) {
                    this.retriggeredFreeSpins = currentFreespinsRemaining + TOTAL_FREESPIN_COUNT;
                } else {
                    this.retriggeredFreeSpins = this.totalFreespinsCount + TOTAL_FREESPIN_COUNT;
                }
            } else {
                if (this.freespinsAmount === data.context.freeSpinRemaining && this.totalFreespinsCount !== 0) {
                    this.freespinCounter.totalFreespins(++this.totalFreespinsCount);
                }
                this.retriggeredFreeSpins = null;

            }
            this.freespinsAmount = data.context.freeSpinRemaining;

        }, this);
        PSEvents.subscribe(PSEvents.GENERIC_FREE_RETRIGGER, (data) => {
            this.panel.node.emit('generic/freeSpinsRetrigger', data);
        }, this);
        PSEvents.subscribe(PSEvents.STATE_UPDATED, (data) => {
            if (data.hasOwnProperty('quickSpinFeature')) {
                this.isFastMode = data.quickSpinFeature;
                if (this.isFastMode && !GenericUI.isPaused()) {
                    this.panel.slamStop();
                }
            }
        }, this);
        PSEvents.subscribe(PSEvents.BET_CHANGED, () => {
            if (this.state === GameStates.MAIN) {
                this.wildProgress.set(this.mainSpecialWildProgress);
            }
        }, this);
    },

    startFreespinState() {
        this.featureGameMode = FeatureStates.ACTIVE;
        GenericUI.enableSpinButton();
        this.audioMap.playSfx('Rope Appear');
        this.freespinCounter.show();
    },

    onFreespinsPopupButtonClick() {
        GenericUI.setDefaultSpinButtonHandler();
        GenericUI.disableSpinButton();

        this.freespinPopup.hide();
        this.audioManager.fadeOutMusic(500, this.musicId, true, () => {
            this.musicId = this.audioMap.playMusic('musicFs');
        });

        this.startFreespinState();
    },

    startMainState() {
        GenericUI.enableSpinButton();
    },

    _setupInitialData() {
        const { MAIN, FREESPINS } = PSState.gameConfiguration.panelConfigurationPerState;
        const data = GenericEngine.getInitData();

        this.state = data.gameState;
        this.prevState = data.prevState;
        this.panel.setInitialPanelData(data, PSState.betAmount, MAIN.preCookedReels.reels, true);
        
        const { wagers, betAmount } = PSState.get();

        if (SlotUI.isReplayMode() && wagers) {
            const { counters } = wagers.data[0].bets[0].eventdata.initialPlayerState;  
            const { SPECIAL_WILD, FREE_SPINS_SPECIAL_WILD } = counters;

            const mainSpecialWildProgress = {
                limit: SPECIAL_WILD.limits[1],
                value: SPECIAL_WILD.value_per_bet
            }
            this.mainSpecialWildProgress = mainSpecialWildProgress;
            
            if (FREE_SPINS_SPECIAL_WILD) {
                fsSpecialWildProgress = {
                    limit: FREE_SPINS_SPECIAL_WILD.limits[1],
                    value: FREE_SPINS_SPECIAL_WILD.value_per_bet
                }
                this.fsSpecialWildProgress = fsSpecialWildProgress;
            } else {
                this.fsSpecialWildProgress = data.fsSpecialWildProgress;
            }

        } else {
            this.mainSpecialWildProgress = data.mainSpecialWildProgress;
            this.fsSpecialWildProgress = data.fsSpecialWildProgress;
        }

        

      
        this.fsSpecialWildProgress = data.fsSpecialWildProgress;
        this.wildProgress.set(this.mainSpecialWildProgress);

        switch (this.state) {
            case GameStates.MAIN:
                this.featureGameMode = FeatureStates.INACTIVE;
                this.startMainState();
                this.panel.setFreespins(false);
                break;
            case GameStates.FREESPINS:
            case GameStates.FREESPINS_SUPER:
                this.panel.setFreespinPanelInitData(FREESPINS.taxonomy, FREESPINS.preCookedReels.reels);
                this.lastMainData = data.newPanelData;
                this.freespinCounter.setFreespins(data.freeSpinRemaining);
                this.freeSpinsRemaining = data.freeSpinRemaining;
                this.featureGameMode = FeatureStates.ACTIVE;
                if (data.freespinsConsumed === 0) {
                    this.featureGameMode = FeatureStates.ENTER;
                }
                this.panel.setFreespins(true);
                this.startFreespinState();
                break;
        }
    },
});
